import { THeading, THeadingTreeNode } from '../types';

/**
 * Given a list of headings, returns:
 *  1) parentMap: an object of { [childId]: parentId | null }
 *  2) a tree-like structure needed for the heading selection UI in `SelectHeadingDialog`
 *
 * @param headings - list of headings
 * @returns { treeHeadings, parentMap }
 */
const buildTreeHeading = (headings: THeading[]) => {
  const treeHeadings: THeadingTreeNode[] = [];
  const parentMap: Record<string, string | null> = {};

  for (const heading of headings) {
    const level0Based = heading.level - 1;
    let currentHeadings = treeHeadings;
    let currentLevel0Based = 0;
    let currentParentId: string | null = null;

    while (currentHeadings.length > 0 && currentLevel0Based < level0Based) {
      const parentHeading = currentHeadings[currentHeadings.length - 1];
      if (parentHeading.level - 1 >= level0Based) break;

      currentHeadings = parentHeading.children;
      currentParentId = parentHeading.id;
      currentLevel0Based = parentHeading.level - 1;
    }

    const node: THeadingTreeNode = {
      id: heading.id,
      level: heading.level,
      text: heading.text,
      numbering: heading.numbering,
      children: [],
    };
    parentMap[node.id] = currentParentId;
    currentHeadings.push(node);
  }

  return { treeHeadings, parentMap };
};

export default buildTreeHeading;
